import accordion from './accordion';
import alert from './alert';
import avatar from './avatar';
import button from './button';
import buttonGroup from './buttonGroup';
import checkbox from './checkbox';
import list from './list';
import popover from './popover';
import progress from './progress';
import tooltip from './tooltip';

export const defaultTheme = {
  avatar,
  accordion,
  alert,
  button,
  buttonGroup,
  checkbox,
  list,
  popover,
  tooltip,
  progress,
};
